
import Footer from "../../Components/LandingSections/Footer"
import AdminPage from "./Adminpage"
import SeeProductPage from "./SeeProductPage"

export const AdminSide=()=>{

    return (
        <div>
            
            <AdminPage/>
            <SeeProductPage/>
            <Footer/>
        </div>
    )
}